import React from 'react';
import PropTypes from 'prop-types';
import './MediaLibraryPlaceholder.scss';


const propTypes = {
  itemsLength: PropTypes.number.isRequired,
};

const libraryPlaceholder = require('./assets/library-placeholder.png');

const MediaLibraryPlaceholder = ({ itemsLength }) => {
  if (!itemsLength) {
    return (
      <div className="library-placeholder">
        <div className="img-wrapper">
          <img src={libraryPlaceholder} alt="" />
        </div>
        <div className="plain-text">
          <span>
                    There are no media files yet.
          </span>
        </div>
      </div>
    );
  }
  return null;
};


MediaLibraryPlaceholder.propTypes = propTypes;


export default MediaLibraryPlaceholder;



// WEBPACK FOOTER //
// ./src/components/_atomic/MediaLibraryPlaceholder/MediaLibraryPlaceholder.js